class ReportService implements IReportService {
    public static $inject = [];

    public reportLists = {
        category: ['Category 1', 'Category 2', 'Category 3'],
        title: ['Title 1', 'Title 2', 'Title 3']
    };

    constructor() {}

    public getReportLists(): any {
        // this will return the lists of available reports from the backend
        return this.reportLists;
    }

    public requestReport(reportFilters: any): any {
        // this function will request the report from the backend with an amended element id param
        let submitData: any = {
            filterData: reportFilters,
            reportID: 'still to fill out'
        };
    }
}

angular.module('beneple.global')
    .service('ReportService', ReportService);



// WEBPACK FOOTER //
// ./frontend/scripts/admin/services/report.service.ts